import { api } from '../config.js'

export const SET_HOST = 'SET_HOST'
export const RECEIVE_FINAL_STEPS = 'GET_FINAL_STEPS'
export const RECEIVE_FINAL_STEPS_ERROR = 'RECEIVE_FINAL_STEPS_ERROR'
export const REQ_FINAL_STEPS = 'REQ_FINAL_STEPS'
export const SET_PAY_WEEKLY = 'SET_PAY_WEEKLY'

export const receiveFinalSteps = (data) => {
  return ({
    type: RECEIVE_FINAL_STEPS,
    data
  })
}
const receiveFinalStepsError = () => {
  return ({
    type: RECEIVE_FINAL_STEPS_ERROR
  })
}
const reqFinalSteps = () =>{
  return ({
    type: REQ_FINAL_STEPS
  })
}
export const setPayWeekly = (data) =>{
  return ({
    type: SET_PAY_WEEKLY,
    data
  })
}
export const fetchFinalSteps = () => dispatch => {
  dispatch(reqFinalSteps())

  const headers = {
    'Accept': 'application/json',
    'Content-Type': 'application/json'
  }

  const method = 'POST'

  return fetch(`${api}/user/user-getRegFinalSteps`, {
    headers,
    method,
    body: JSON.stringify()
  })
    .then(response => response.json())
    .then(json => {
      console.log('user-getRegFinalSteps')
      console.log(json)
      if(json.errorCode === 1){
        dispatch(receiveFinalSteps(json.data))
      } else {
        dispatch(receiveFinalStepsError())
      }
    })
}

export const setHost = host => {
  return {
  type: SET_HOST,
  host
}}



// WEBPACK FOOTER //
// /var/www/build-lk-1/src/actions/signup.js